import { render, staticRenderFns } from "./MenuIconsList.vue?vue&type=template&id=2626f3bb&scoped=true&"
import script from "./MenuIconsList.vue?vue&type=script&lang=js&"
export * from "./MenuIconsList.vue?vue&type=script&lang=js&"
import style0 from "./MenuIconsList.vue?vue&type=style&index=0&id=2626f3bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2626f3bb",
  null
  
)

export default component.exports